import { defineStore } from 'pinia';
import Vue from 'vue';

export const WARNING_IMAGE_TOO_SMALL = 'imageTooSmall';

export const useCompositionWarningStore = defineStore('composition-warning', {
  state: () => ({
    warnings: {}
  }),
  actions: {
    addWarning(uid, warning) {
      if (!Object.prototype.hasOwnProperty.call(this.warnings, uid)) {
        Vue.set(this.warnings, uid, {});
      }
      if (Object.prototype.hasOwnProperty.call(this.warnings[uid], warning)) {
        return;
      }

      Vue.set(this.warnings[uid], warning, true);
    },
    hideWarning(uid, warning = null) {
      if (!Object.prototype.hasOwnProperty.call(this.warnings, uid)) {
        return;
      }
      if (warning) {
        if (
          !Object.prototype.hasOwnProperty.call(this.warnings[uid], warning)
        ) {
          return;
        }
        Vue.set(this.warnings[uid], warning, false);
        return;
      }
      Object.keys(this.warnings[uid]).forEach(listedWarning =>
        Vue.set(this.warnings[uid], listedWarning, false)
      );
    },
    removeWarning(uid, warning = null) {
      if (!Object.prototype.hasOwnProperty.call(this.warnings, uid)) {
        return;
      }
      if (warning) {
        if (
          !Object.prototype.hasOwnProperty.call(this.warnings[uid], warning)
        ) {
          return;
        }
        Vue.delete(this.warnings[uid], warning);
        return;
      }
      Vue.delete(this.warnings, uid);
    },
    hasWarnings(uid) {
      if (
        !Object.prototype.hasOwnProperty.call(this.warnings, uid) ||
        Object.keys(this.warnings[uid]).length > 0
      ) {
        return false;
      }
      return true;
    },
    hasActiveWarnings(uid) {
      return this.getActiveWarnings(uid).length > 0;
    },
    getActiveWarnings(uid) {
      if (!Object.prototype.hasOwnProperty.call(this.warnings, uid)) {
        return [];
      }
      return Object.keys(this.warnings[uid]).filter(
        warning => this.warnings[uid][warning]
      );
    }
  }
});
